import { LoadingButton } from '@mui/lab'
import { Box, Button, IconButton, Typography } from '@mui/material'
import { icons } from '../../../utils/icons'
import BaseModal from '../baseModal'
import { Props } from './props'
import { useStyles } from './styles'

const SimpleModal = ({ open, close, title, description, buttonText, cancelText, next, back, containerBox, loadingButton, isLoading, removeClose, children, sx, removeButtons, disableButton, icon, errorMsg, closeProps }: Props) => {
  const styles = useStyles(!!back)
  return (
    <BaseModal open={open} sx={{ width: '350px', maxHeight: '90vh', overflow: 'auto', ...(sx ?? {}) }}>
      <Box sx={styles.containerSuccess}>
        {
          !removeClose && (
            <IconButton
              {...closeProps}
              sx={closeProps?.sx ?? styles.closeSuccess}
              onClick={() => {
                close()
              }}
            >
              {icons('simple-close')}
            </IconButton>
          )
        }
        <Box className="container" {...containerBox}>
          {!!icon && icon}
          {!!title && <Typography className="title">{title}</Typography>}
          {!!description && <Typography dangerouslySetInnerHTML={{ __html: description }} className="description" />}
          {!!errorMsg && <Typography className="errorMsg">{errorMsg}</Typography>}
          {children}
        </Box>

        {!removeButtons && (
          <>
            <hr />
            <Box sx={styles.buttonContainer}>
              {!!back && (
                <Button
                  className="cancel"
                  onClick={() => {
                    back()
                  }}
                >
                  {cancelText ?? ''}
                </Button>
              )}
              {!!loadingButton ? (
                <LoadingButton
                  className="continue"
                  loading={isLoading}
                  disabled={disableButton || isLoading}
                  onClick={() => {
                    next()
                  }}
                >
                  {buttonText}
                </LoadingButton>
              ) : (
                <Button
                  disabled={!!disableButton}
                  className="continue"
                  onClick={() => {
                    next()
                  }}
                >
                  {buttonText}
                </Button>
              )}
            </Box>
          </>
        )}
      </Box>
    </BaseModal>
  )
}

export default SimpleModal
